<template>
  <div class="home-section5">
    <div class="section5-title">
      <div class="color-line1"></div>
      <div class="color-line2"></div>
      <div>
        <img src="../../../assets/image/home-teacher-icon.png" alt="名师风采" />
        <span>名师风采</span>
      </div>
      <div @click="handleMore">
        <span>查看更多</span>
        <img src="../../../assets/image/home-inform-icon2.png" alt="查看更多" />
      </div>
    </div>
    <div id="carousel">
        <img src="@/assets/images/icon-swiper-left.png" class="swiper-button-prev" id='icon-swiper-left' alt="">
        <div class="swiper swiper-3d">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(sub, subInd) in teacherList"
                  :key="subInd"
                   @click="handleItem(sub)">
              <div class="swiper-item" 
              >
                <div>
                  <img :src="sub.teacherPropagateUrl" :alt="sub.name" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src="@/assets/images/icon-swiper-right.png" class="swiper-button-next" id='icon-swiper-left' alt="">
        <div class="swiper-pagination"></div>
    </div>
    <!-- <div class="section5-swiper">
      <el-carousel
        arrow="always"
        trigger="click"
        :autoplay="false"
        height="260px"
      >
        <el-carousel-item
          v-for="index in Math.ceil(teacherList.length / 4)"
          :key="index"
        >
          <div class="swiper-item">
            <div
              v-for="(sub, subInd) in teacherList.slice(
                (index - 1) * 4,
                index * 4
              )"
              :key="sub.name + subInd"
              @click="handleItem(sub)"
            >
              <img :src="sub.teacherPropagateUrl" :alt="sub.name" />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div> -->
  </div>
</template>
<script>
import * as API from '../../../api/home/index'
export default {
  name: 'HomeSection5',
  data() {
    return {
      teacherList: []
    }
  },
  created() {
    this.getTeacherList()
  },
  methods: {
    handleMore() {
      this.$router.push({
        path: '/teacherList'
      })
    },
    async getTeacherList() {
      try {
        const params = {
          page: 1,
          limit: -1,
          recommendState: 2
        }
        const res = await API.getHomeTeacherSwiper(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.teacherList = records
          this.$nextTick(() => {
            this.newSwiper()
          })
        }
      } catch (error) {}
    },
    newSwiper() {
      const slideW = 300
      const radius = slideW * 0.5 / Math.sin(Math.PI / 16)
      /* eslint-disable no-new */
      new window.Swiper('#carousel .swiper', {
          watchSlidesProgress: true,
          slidesPerView: 'auto',
          centeredSlides: false,
          loop: true,
          loopedSlides: 4,
          grabCursor: true,
          autoplay: true,
          navigation: {
              nextEl: '#carousel .swiper-button-next',
              prevEl: '#carousel .swiper-button-prev'
          },
          pagination: {
              el: '#carousel .swiper-pagination',
              clickable: true
          },
          on: {
              progress: function(swiper, progress) {
                  for (var i = 0; i < this.slides.length; i++) {
                      var slide = this.slides.eq(i)
                      var slideProgress = this.slides[i].progress
                      var translateX = (slideProgress + 1.5) * (slideW / 3 - Math.cos((slideProgress + 1.5) * 0.125 * Math.PI) * slideW * 1.1 / 3) + 'px'
                      var rotateY = (slideProgress + 1.5) * 22.5
                      var translateZ = (radius - Math.cos((slideProgress + 1.5) * 0.125 * Math.PI) * radius - 150) + 'px'
                      slide.transform('translateX(' + translateX + ') translateZ(' + translateZ + ') rotateY(' + rotateY + 'deg)')
                  }
              },
              setTransition: function(swiper, transition) {
                  for (var i = 0; i < this.slides.length; i++) {
                      var slide = this.slides.eq(i)
                      slide.transition(transition)
                  }
              }
          }
      })
    },
    handleItem(item) {
      this.$router.push({
        path: '/teacherIntroduce',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.home-section5 {
  margin-bottom: 61px;
  // background: rgb(250, 250, 254);
  .section5-title {
    height: 57px;
    background: linear-gradient(0deg, #ffffff 0%, #ececeb 100%);
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .color-line1 {
      position: absolute;
      width: 1182px;
      height: 2px;
      background: #085dc8;
      opacity: 0.35;
      top: 0;
      left: 18px;
    }
    .color-line2 {
      position: absolute;
      width: 128px;
      height: 4px;
      background: #ff4e4e;
      top: 0;
      left: 18px;
    }
    > div:nth-child(3) {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;

      > img {
        width: 30px;
        height: 30px;
        margin: 0 13px 0 18px;
      }
    }

    > div:last-child {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      cursor: pointer;

      > img {
        width: 18px;
        height: 18px;
        vertical-align: middle;
        margin: 0 15px 0 3px;
      }
    }
  }
  .section5-swiper {
    width: 100%;
    .swiper-item {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 auto;
      > div {
        width: 254px;
        height: 190px;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 10px;
        cursor: pointer;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
<style scoped>
#carousel {
    position: relative;
    width: 90%;
    margin: 0 auto;
}
.icon-swiper-left{
  cursor: pointer;
  width: 60px;
  height: 60px;
  margin: auto;
  z-index: 11;
  position: absolute;
  left: -40px;
  top: 0;
  bottom: 0;
}
.icon-swiper-right{
  cursor: pointer;
  width: 60px;
  height: 60px;
  z-index: 11;
  margin: auto;
  position: absolute;
  right: -40px;
  top: 0;
  bottom: 0;
}
#carousel .swiper {
    padding-top: 20px;
    padding-bottom: 40px;
}

#carousel .swiper-wrapper {}

#carousel .swiper-slide {
    width: 270px;
    /* height: 210px; */
    overflow: hidden;
    /* background: #fff; */
    box-shadow: 0 0px 10px #ccc;
}

#carousel .swiper-slide img {
    display: block;
    width: 100%;
}

#carousel .swiper-slide p,
#carousel .swiper-slide h3 {
    line-height: 58px;
    padding-top: 0;
    text-align: center;
    color: #636363;
    font-size: 0.8em;
    margin: 0;
}

#carousel .swiper-pagination {
    width: 100%;
    bottom: 20px;
}

#carousel .swiper-pagination-bullets /deep/ .swiper-pagination-bullet {
    margin: 0 5px;
    background-color: #FFBFC3;
    width: 12px;
    height: 12px;
    opacity: 1;
    border-radius: 5px;
}

#carousel .swiper-pagination-bullets /deep/ .swiper-pagination-bullet-active {
    background-color: #FF4E4E;
    width: 50px;
}

#carousel .swiper-button-prev {
    left: -48px;
    width: 45px;
    height: 45px;
    background-position: 0 0;
    background-size: 100%;
}

#carousel .swiper-button-prev:hover {
    background-position: 0 -46px;
    background-size: 100%
}

#carousel .swiper-button-next {
    right: -48px;
    width: 45px;
    height: 45px;
    background-position: 0 -93px;
    background-size: 100%;
}

#carousel .swiper-button-next:hover {
    background-position: 0 -139px;
    background-size: 100%
}

#carousel .swiper-button-prev::after,
#carousel .swiper-button-next::after {
    content: '';
}
</style>
